{
  "dashboard": {
    "place": {
      "inShift": "Now at {{clinic}} · until {{end}}",
      "between": "Next shift: {{clinic}} · {{start}}",
      "beforeFirst": "Today: {{clinic}} from {{start}}",
      "done": "Today's shift is over · {{clinic}}",
      "overlap": "Scheduled at {{count}} practices at once",
      "noShiftToday": "No hours registered for today",
      "noShiftDay": "No hours registered for this day",
      "noShiftHint": "Your practice registers your hours",
      "otherDay": "{{weekday}}: {{clinic}} {{hours}}",
      "more": "and {{count}} more",
      "aria": "Where your schedule puts you"
    },
    "stats": {
      "total": "booked",
      "waiting": "waiting",
      "completed": "seen",
      "cancelled": "cancelled",
      "aria": "{{total}} booked, {{waiting}} waiting, {{completed}} seen, {{cancelled}} cancelled",
      "share": "Share: {{amount}}",
      "shareNoFigure": "Share"
    },
    "week": {
      "title": "Pick a day",
      "thisWeek": "This week",
      "nextWeek": "Next week",
      "prevWeek": "Last week",
      "range": "{{from}} – {{to}}",
      "fullCalendar": "Full calendar",
      "backToWeek": "Back to the week",
      "countAria": "{{count}} appointments"
    },
    "clinic": {
      "auto": "Automatic — follow my schedule",
      "autoSub": "The practice your schedule names for this day",
      "autoBadge": "Auto"
    },
    "book": {
      "open": "New appointment",
      "title": "Book an appointment",
      "clinic": "Clinic",
      "patient": "Patient",
      "searchLabel": "Find a patient",
      "searchPlaceholder": "Name, phone or national ID",
      "searchHint": "Type at least two characters.",
      "noMatch": "No patient on your list matches this.",
      "truncated": "Showing the first {{count}} results; narrow the search.",
      "newPatient": "New patient",
      "pickExisting": "Choose from patients",
      "change": "Change",
      "name": "Full name",
      "phone": "Mobile number",
      "nationalId": "National ID (optional)",
      "when": "Date and time",
      "duration": "Length",
      "minutes": "{{count}} min",
      "note": "Note (optional)",
      "submit": "Book appointment",
      "submitRequest": "Send for clinic approval",
      "needsApprovalTitle": "Needs clinic approval",
      "needsApproval": "Appointments you book at this clinic are final only once reception confirms them; until then they stay “awaiting clinic confirmation”.",
      "booked": "Appointment booked.",
      "requested": "Appointment sent to the clinic for approval.",
      "loadFailed": "Could not load your clinics.",
      "noClinic": "You cannot book at any clinic right now.",
      "searchFailed": "Patient search failed.",
      "modeFirstDay": "First slot this day",
      "modeFirstToday": "First slot today",
      "modeManual": "Pick a time",
      "showTimeOptions": "Change the day or how the time is picked",
      "hideTimeOptions": "Hide time options",
      "noneLeftToday": "There are no free slots left today.",
      "finding": "Finding the next free slot…",
      "bookThisOne": "Book it",
      "firstFree": "First free slot",
      "exactAtBooking": "The exact time is settled when you book.",
      "firstSlotFailed": "The next free slot could not be found. You can pick a time yourself.",
      "lessOptions": "Hide more options",
      "typeInPerson": "In person",
      "typeOnline": "Remote",
      "submitFirst": "Book the first appointment",
      "walkIn": "Walk-in, right now",
      "walkInOff": "The patient is here now; add them to today’s queue without a time.",
      "walkInOn": "Booked without a time; the patient joins today’s queue now.",
      "walkInOnShort": "No time; joins today’s queue.",
      "walkInLead": "No free slots left today; add the patient to today’s queue now, without a time.",
      "walkInLeadShort": "No time, today’s queue.",
      "walkInNoGrant": "At this clinic your bookings wait for reception; a patient who is already here is added by the clinic’s reception.",
      "walkInNoGrantShort": "At this clinic only reception can add a walk-in.",
      "alreadyOpen": {
        "scheduled": "This patient already has another appointment today that has not arrived yet.",
        "arrived": "This patient is already in today's queue — is a second appointment needed?",
        "in_visit": "This patient is in a visit right now — is a second appointment needed?"
      },
      "submitWalkIn": "Book and add to queue",
      "walkInBooked": "Patient added to today’s queue.",
      "mode": "How to pick the time",
      "day": "Day",
      "visitType": "Visit type",
      "moreOptions": "More options (visit type, length, note)",
      "noneThisDay": "You have no free slot on this day.",
      "nextIs": "Your next free slot:",
      "noneIn30Days": "No free slot was found in the next 30 days either.",
      "slotAt": "{{date}}, {{time}}",
      "errors": {
        "clinic": "Choose a clinic.",
        "patient": "Choose a patient.",
        "name": "Enter the patient’s name.",
        "phone": "This mobile number is not valid.",
        "nationalId": "This national ID is not valid.",
        "when": "Enter the date and time.",
        "past": "This time has already passed.",
        "noSlot": "No free slot on this day; pick another day or enter the time yourself."
      }
    },
    "withdraw": {
      "action": "Withdraw request",
      "title": "Withdraw appointment request",
      "message": "Withdraw the appointment request for {{name}}? It will be removed from the clinic’s list.",
      "confirm": "Withdraw request",
      "keep": "Cancel",
      "failed": "Could not withdraw the request."
    },
    "reschedule": {
      "action": "Change time",
      "title": "Change appointment time",
      "current": "Current time: {{when}}",
      "newTime": "New time",
      "hint": "The appointment is moved, not cancelled and booked again, so its invoice and payment stay as they are.",
      "submit": "Save new time",
      "moved": "The appointment was moved to {{when}}."
    }
  },
  "nav": {
    "mobile": {
      "more": "More",
      "moreTitle": "More",
      "account": "Account",
      "sections": "Sections",
      "balance": "{{coin}} balance"
    }
  }
}
